import React from 'react';
import {ThemeProvider} from '@mui/material/styles';

import createTheme from './createTheme.js';

/** Themes */

// ToDo: make the mode an Env setting or Global var
// look into responsivefontsizes util
export const lightTheme = createTheme('light');
export const darkTheme = createTheme('dark');

// https://material-ui.com/styles/advanced/#theming
// hook that will pass the dark theme to the nested component
// useful to switch between dark and light on specific components
export const withDarkTheme = Component => props => (
  <ThemeProvider theme={darkTheme}>
    <Component {...props} />
  </ThemeProvider>
);

export const withLightTheme = Component => props => (
  <ThemeProvider theme={lightTheme}>
    <Component {...props} />
  </ThemeProvider>
);
